import React from 'react';

import { Circle, Icon, Layout, Text } from 'ds';
import FeedbackThumbControls from 'ds/FeedbackRequests/FeedbackThumbControls';

interface Props {
  text: string;
  handleFeedback: (liked: boolean) => void;
  disabled?: boolean;
  includeModal?: boolean;
  liked?: boolean | null;
}

const FeedbackSubwidget: React.FC<Props> = ({ text, handleFeedback, liked, includeModal = true, ...props }) => {
  const disabled = liked === true || liked === false || props.disabled;
  return (
    <Layout gap={8}>
      <Circle dimension={20} color="green-700">
        <Icon stroke={2} name="checkmark" color="white" size={12} />
      </Circle>
      <Layout gap={12} direction="column">
        <Text size="body-xs">{text}</Text>
        <Layout gap={4} align="center">
          <Text size="body-xs" color="gray-400">
            How did it go?
          </Text>
          <FeedbackThumbControls
            liked={liked}
            disabled={disabled}
            handleFeedback={({ liked }) => handleFeedback(liked)}
            includeModal={includeModal}
          />
        </Layout>
      </Layout>
    </Layout>
  );
};

export default FeedbackSubwidget;
